module.exports = __webpack_public_path__ + "static/media/temp_18.9ed7b402.jpg";